import AppBar from '@mui/material/AppBar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { makeStyles } from '@mui/styles';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import NavbarToggleButton from 'app/fuse-layouts/shared-components/NavbarToggleButton';
import clsx from 'clsx';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectToolbarTheme } from 'app/store/fuse/settingsSlice';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
	root: {}
}));

function ToolbarLayout2(props) {
	const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
	const toolbarTheme = useSelector(selectToolbarTheme);
	const theme = useTheme();
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

	const classes = useStyles(props);

	return (
		<ThemeProvider theme={toolbarTheme}>
			<AppBar
				id="fuse-toolbar"
				className={clsx(classes.root, 'flex relative z-20 shadow-md', props.className)}
				color="default"
				sx={{
					background: 'linear-gradient(90deg, rgb(15, 23, 42) 0%, rgb(30, 58, 138) 100%)',
					color: '#fff'
				}}
			>
				<Toolbar className="container p-0 lg:px-24 min-h-48 md:min-h-0">
					{config.navbar.display && !isLgUp && (
						<NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
					)}

					{/* <div className="flex flex-1">
						<Hidden mdDown>
							<FuseShortcuts />
						</Hidden>
					</div> */}

				{/*  <div className="flex items-center px-8 h-full overflow-x-auto">
						<LanguageSwitcher />

						<AdjustFontSize />

						<FullScreenToggle />

						<FuseSearch />

						<QuickPanelToggleButton />

						<UserMenu />
					</div> */} 
				</Toolbar>
			</AppBar>
		</ThemeProvider>
	);
}

ToolbarLayout2.propTypes = {
  className: PropTypes.string,
};

export default memo(ToolbarLayout2);
